import { gql } from '@apollo/client/core';

export const DSR_REQUESTS = gql`
  query dsrRequests {
    dsrRequests {
      edges {
        node {
          account {
            id
          }
          createdAt
          optOut
        }
      }
    }
  }
`;

export default DSR_REQUESTS;
